import React, { useState, useEffect, useCallback, useRef } from "react";
import { useDropzone } from "react-dropzone";
import { Link } from "react-router-dom";
import SellerNavbar from "../../component/SellerNavbar";
import SellerSidebar from "../../component/SellerSidebar";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Swal from "sweetalert2";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import AddMoreCategory from "./SellerComp/AddMoreCategory";

const SellerListingCreate = () => {
  const quillRef = useRef(null);

  const [showCategory, setShowCategory] = useState(false);

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    listingCondition: "",
    listingStandard: "",
    listingBrand: "",
    listingCategory: "",
    listingType: "directSell",
    price: "",
    mrp: "",
    currency: "INR",
    quantity: "",
    unitquantity: "",
    upc: "",
    mpn: "",
    hsn: "",
    modal: "",
    manufacturer: "",
    state: "",
    unlimitedQuantity: false,
    uploadedFiles: [],
    listingCategoryTwo: "",
    gst: "",
    availableat: "",
    weight: "",
    product_type: "",
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleCategoryChangetwo = (categoriesData) => {
    setFormData({ ...formData, listingCategoryTwo: categoriesData });
  };

  const handleRemoveCategory = () => {
    setFormData((prevData) => ({
      ...prevData,
      listingCategoryTwo: null,
    }));
    setShowCategory(false);
  };

  const [loading, setLoading] = useState(false);

  const [menus, setMenus] = useState([]);
  const [mainCategories, setMainCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [subSubCategories, setSubSubCategories] = useState([]);
  const [subSubSubCategories, setSubSubSubCategories] = useState([]);
  const [finalCategories, setFinalCategories] = useState([]);
  const [sixCategories, setSixCategories] = useState([]);
  const [seventhCategories, setSeventhCategories] = useState([]);
  const [eightCategories, setEightCategories] = useState([]);
  const [nineCategories, setNineCategories] = useState([]);

  const [selectedMainCategory, setSelectedMainCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedSubSubCategory, setSelectedSubSubCategory] = useState("");
  const [selectedSubSubSubCategory, setSelectedSubSubSubCategory] = useState("");
  const [selectedFinalCategory, setSelectedFinalCategory] = useState("");
  const [selectedSixCategory, setSelectedSixCategory] = useState("");
  const [selectedSeventhCategory, setSelectedSeventhCategory] = useState("");
  const [selectedEightCategory, setSelectedEightCategory] = useState("");
  const [selectedNineCategory, setSelectedNineCategory] = useState("");

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    axios
      .get(`${baseurl}getMenus`)
      .then((response) => {
        setMenus(response.data);
        setMainCategories(response.data.filter((menu) => menu.parent_id === null));
      })
      .catch((error) => console.error("Error fetching menus:", error));
  }, []);

  const handleMainCategoryChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setSelectedMainCategory(selectedId);
    setSubCategories(menus.filter((menu) => menu.parent_id === selectedId));
    setSelectedSubCategory("");
    setSubSubCategories([]);
    setSelectedSubSubCategory("");
    setSubSubSubCategories([]);
    setSelectedSubSubSubCategory("");
    setFinalCategories([]);
    setSelectedFinalCategory("");
    setSixCategories([]);
    setSelectedSixCategory("");
    setSeventhCategories([]);
    setSelectedSeventhCategory("");
    setEightCategories([]);
    setSelectedEightCategory("");
    setNineCategories([]);
    setSelectedNineCategory("");
  };

  const handleSubCategoryChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setSelectedSubCategory(selectedId);
    setSubSubCategories(menus.filter((menu) => menu.parent_id === selectedId));
    setSelectedSubSubCategory("");
    setSubSubSubCategories([]);
    setSelectedSubSubSubCategory("");
    setFinalCategories([]);
    setSelectedFinalCategory("");
    setSixCategories([]);
    setSelectedSixCategory("");
    setSeventhCategories([]);
    setSelectedSeventhCategory("");
    setEightCategories([]);
    setSelectedEightCategory("");
    setNineCategories([]);
    setSelectedNineCategory("");
  };

  const handleSubSubCategoryChange = (e) => {
    const selectedCategoryId = parseInt(e.target.value);
    setCategories(selectedCategoryId);
    handleCategoryChange({ value: selectedCategoryId });
    const selectedId = parseInt(e.target.value);
    setSelectedSubSubCategory(selectedId);
    setSubSubSubCategories(menus.filter((menu) => menu.parent_id === selectedId));
    setSelectedSubSubSubCategory("");
    setFinalCategories([]);
    setSelectedFinalCategory("");
    setSixCategories([]);
    setSelectedSixCategory("");
    setSeventhCategories([]);
    setSelectedSeventhCategory("");
    setEightCategories([]);
    setSelectedEightCategory("");
    setNineCategories([]);
    setSelectedNineCategory("");
  };

  const handleSubSubSubCategoryChange = (e) => {
    const selectedCategoryId = parseInt(e.target.value);
    setCategories(selectedCategoryId);
    handleCategoryChange({ value: selectedCategoryId });
    const selectedId = parseInt(e.target.value);
    setSelectedSubSubSubCategory(selectedId);
    setFinalCategories(menus.filter((menu) => menu.parent_id === selectedId));
    setSelectedFinalCategory("");
    setSixCategories([]);
    setSelectedSixCategory("");
    setSeventhCategories([]);
    setSelectedSeventhCategory("");
    setEightCategories([]);
    setSelectedEightCategory("");
    setNineCategories([]);
    setSelectedNineCategory("");
  };

  const handleFinalCategoryChange = (e) => {
    const selectedCategoryId = parseInt(e.target.value);
    setCategories(selectedCategoryId);
    handleCategoryChange({ value: selectedCategoryId });
    const selectedId = parseInt(e.target.value);
    setSelectedFinalCategory(selectedId);
    setSixCategories(menus.filter((menu) => menu.parent_id === selectedId));
    setSelectedSixCategory("");
    setSeventhCategories([]);
    setSelectedSeventhCategory("");
    setEightCategories([]);
    setSelectedEightCategory("");
    setNineCategories([]);
    setSelectedNineCategory("");
  };

  const handleSixCategoryChange = (e) => {
    const selectedCategoryId = parseInt(e.target.value);
    setCategories(selectedCategoryId);
    handleCategoryChange({ value: selectedCategoryId });
    const selectedId = parseInt(e.target.value);
    setSelectedSixCategory(selectedId);
    setSeventhCategories(menus.filter((menu) => menu.parent_id === selectedId));
    setSelectedSeventhCategory("");
    setEightCategories([]);
    setSelectedEightCategory("");
    setNineCategories([]);
    setSelectedNineCategory("");
  };

  const handleSeventhCategoryChange = (e) => {
    const selectedCategoryId = parseInt(e.target.value);
    setCategories(selectedCategoryId);
    handleCategoryChange({ value: selectedCategoryId });
    const selectedId = parseInt(e.target.value);
    setSelectedSeventhCategory(selectedId);
    setEightCategories(menus.filter((menu) => menu.parent_id === selectedId));
    setSelectedEightCategory("");
    setNineCategories([]);
    setSelectedNineCategory("");
  };

  const handleEightCategoryChange = (e) => {
    const selectedCategoryId = parseInt(e.target.value);
    setCategories(selectedCategoryId);
    handleCategoryChange({ value: selectedCategoryId });
    const selectedId = parseInt(e.target.value);
    setSelectedEightCategory(selectedId);
    setNineCategories(menus.filter((menu) => menu.parent_id === selectedId));
    setSelectedNineCategory("");
  };

  const handleNineCategoryChange = (e) => {
    const selectedCategoryId = parseInt(e.target.value);
    setCategories(selectedCategoryId);
    handleCategoryChange({ value: selectedCategoryId });
    const selectedId = parseInt(e.target.value);
    setSelectedNineCategory(selectedId);
  };

  const handleCategoryChange = (selectedOption) => {
    setFormData((prevData) => ({
      ...prevData,
      listingCategory: selectedOption ? selectedOption.value : "",
    }));
  };

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(`${baseurl}getAllCountries`);
        setCountries(response.data.countries);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };
    fetchCountries();
  }, []);

  useEffect(() => {
    if (formData.manufacturer) {
      const fetchStates = async () => {
        try {
          const response = await axios.get(
            `${baseurl}getAllStatesByCountryId/${formData.manufacturer}`
          );
          setStates(response.data.states);
        } catch (error) {
          console.error("Error fetching states:", error);
        }
      };
      fetchStates();
    } else {
      setStates([]);
    }
  }, [formData.manufacturer]);

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${baseurl}getMenusByCategory`);
        if (response.data) {
          const categoryOptions = response.data.map((category) => ({
            value: category.id,
            label: category.path,
          }));
          setCategories(categoryOptions);
        }
      } catch (error) {
        // console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [previewFiles, setPreviewFiles] = useState([]);
  const [videoCount, setVideoCount] = useState(0);

  const allowedImageExtensions = ["jpg", "jpeg", "png", "webp", "avif"];

 const { getRootProps, getInputProps } = useDropzone({
  // Accept all file types
  accept: {
    "*/*": [],
  },
  multiple: true,
  maxFiles: 10,
  onDrop: async (acceptedFiles) => {
    let newFiles = [...uploadedFiles];
    let newPreviews = [...previewFiles];
    let newVideoCount = videoCount;

    for (let file of acceptedFiles) {
      // Check video duration only if it is a video
      if (file.type.startsWith("video/")) {
        if (newVideoCount >= 1) {
          Swal.fire("Error", "Only 1 video is allowed.", "error");
          continue;
        }
        const videoDuration = await getVideoDuration(file);
        if (videoDuration > 60) {
          Swal.fire("Error", "Video duration should be max 1 minute.", "error");
          continue;
        }
        newVideoCount += 1;
      }

      // Check total file limit
      if (newFiles.length >= 10) {
        Swal.fire("Error", "Maximum 10 files allowed.", "error");
        break;
      }

      newFiles.push(file);

      // Generate preview for images/videos, otherwise null
      if (file.type.startsWith("image/") || file.type.startsWith("video/")) {
        newPreviews.push(URL.createObjectURL(file));
      } else {
        newPreviews.push(null);
      }
    }

    setUploadedFiles(newFiles);
    setPreviewFiles(newPreviews);
    setVideoCount(newVideoCount);
    setFormData((prevData) => ({
      ...prevData,
      uploadedFiles: newFiles,
    }));
  },
});

  const getVideoDuration = (file) => {
    return new Promise((resolve) => {
      const video = document.createElement("video");
      video.preload = "metadata";
      video.onloadedmetadata = () => {
        resolve(video.duration);
      };
      video.src = URL.createObjectURL(file);
    });
  };

  const removeFile = (index) => {
    const newFiles = uploadedFiles.filter((_, i) => i !== index);
    const newPreviews = previewFiles.filter((_, i) => i !== index);
    setUploadedFiles(newFiles);
    setPreviewFiles(newPreviews);
    setFormData((prevData) => ({
      ...prevData,
      uploadedFiles: newFiles,
    }));
  };

  const onDrop = useCallback((acceptedFiles) => {
    setFormData((prevData) => ({
      ...prevData,
      uploadedFiles: [...prevData.uploadedFiles, ...acceptedFiles],
    }));
  }, []);

  const handleDescriptionChange = (content) => {
    setFormData({ ...formData, description: content });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: checked,
      ...(name === "unlimitedQuantity" && checked ? { quantity: "" } : {}),
    }));
  };

  // ✅ FIXED: Each field now has its own error key and message
  const validateForm = () => {
    let formErrors = {};

    if (!formData.title.trim()) {
      formErrors.title = "Title is required.";
      toastr.error("Title is required.", "Error", { timeOut: 5000 });
    }

    if (!formData.listingCondition) {
      formErrors.listingCondition = "Listing condition is required.";
      toastr.error("Listing condition is required.", "Error", { timeOut: 5000 });
    }

    if (!formData.listingStandard) {
      formErrors.listingStandard = "Listing standard is required.";
      toastr.error("Listing standard is required.", "Error", { timeOut: 5000 });
    }

    if (!formData.listingType) {
      formErrors.listingType = "Listing type is required.";
      toastr.error("Listing type is required.", "Error", { timeOut: 5000 });
    }

    if (!formData.price) {
      formErrors.price = "Price is required.";
      toastr.error("Price is required.", "Error", { timeOut: 5000 });
    }

    if (!formData.unlimitedQuantity && !formData.quantity) {
      formErrors.quantity = "Quantity is required.";
      toastr.error("Quantity is required.", "Error", { timeOut: 5000 });
    }

    if (formData.uploadedFiles.length === 0) {
      formErrors.uploadedFiles = "At least one image is required.";
      toastr.error("At least one image is required.", "Error", { timeOut: 5000 });
    }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (!validateForm()) {
      setIsLoading(false);
      return;
    }

    const formSubmission = new FormData();
    const sellerId = localStorage.getItem("seller_id");
    formSubmission.append("seller_id", sellerId);
    formSubmission.append("title", formData.title);
    formSubmission.append("description", formData.description);
    formSubmission.append("listingCondition", formData.listingCondition);
    formSubmission.append("listingStandard", formData.listingStandard);
    formSubmission.append("listingBrand", formData.listingBrand);
    formSubmission.append("listingCategory", formData.listingCategory);
    formSubmission.append("listingType", formData.listingType);
    formSubmission.append("price", formData.price);
    formSubmission.append("mrp", formData.mrp);
    formSubmission.append("currency", formData.currency);
    formSubmission.append("quantity", formData.quantity);
    formSubmission.append("unlimitedQuantity", formData.unlimitedQuantity);
    formSubmission.append("unitquantity", formData.unitquantity);
    formSubmission.append("upc", formData.upc);
    formSubmission.append("mpn", formData.mpn);
    formSubmission.append("hsn", formData.hsn);
    formSubmission.append("modal", formData.modal);
    formSubmission.append("manufacturer", formData.manufacturer);
    formSubmission.append("state", formData.state);
    formSubmission.append("listingCategoryTwo", formData.listingCategoryTwo);
    formSubmission.append("gst", formData.gst);
    formSubmission.append("availableat", formData.availableat);
    formSubmission.append("weight", formData.weight);
    formSubmission.append("product_type", formData.product_type);

    formData.uploadedFiles.forEach((file) => {
      formSubmission.append("uploadedFiles", file);
    });

    try {
      const response = await axios.post(
        `${baseurl}create_listing`,
        formSubmission,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 201) {
        const { listing_unique_id } = response.data.data;
        Swal.fire({
          icon: "success",
          title: "Listing Created!",
          text: response.data.message,
          confirmButtonText: "Continue",
        }).then(() => {
          navigate(`/seller/listing-two/${listing_unique_id}`);
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: response.data.message || "Something went wrong. Please try again.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message ||
          "Server error. Please check your internet connection.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <SellerNavbar />
      <div>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 g-2 justify-content-center">
              <div className="col-md-2">
                <SellerSidebar />
              </div>

              <div className="col-md-10">
                <div className="reviewcls text-start">
                  <h4 className="selh1">Create New Listing</h4>
                  <hr />
                  <form className="contact-form text-start" onSubmit={handleSubmit}>
                    <div className="row g-4">

                      {/* Title */}
                      <div className="col-md-12">
                        <label htmlFor="title" className="form-label">
                          Title<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="title"
                          name="title"
                          className={`form-control ${errors.title ? "is-invalid" : ""}`}
                          placeholder="Enter your listing title"
                          value={formData.title}
                          onChange={handleInputChange}
                          required
                        />
                        {errors.title && (
                          <small className="text-danger">{errors.title}</small>
                        )}
                      </div>

                      {/* Listing Condition */}
                      <div className="col-md-6">
                        <label htmlFor="listingCondition" className="form-label">
                          Listing Condition<span className="text-danger">*</span>
                        </label>
                        <select
                          id="listingCondition"
                          name="listingCondition"
                          className={`form-control ${errors.listingCondition ? "is-invalid" : ""}`}
                          value={formData.listingCondition}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select a condition</option>
                          <option value="used">Used</option>
                          <option value="new">New</option>
                          <option value="refurbished">Refurbished</option>
                          <option value="forParts">For Parts/Not Working</option>
                          <option value="notSpecified">Not Specified</option>
                        </select>
                        {errors.listingCondition && (
                          <small className="text-danger">{errors.listingCondition}</small>
                        )}
                      </div>

                      {/* Categories */}
                      <div className="row g-2 bg-white pb-3">
                        <div className="col-md-4">
                          <label className="form-label">
                            Item Category<span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-select"
                            value={selectedMainCategory}
                            onChange={handleMainCategoryChange}
                            required
                          >
                            <option value="">Select Main Category</option>
                            {mainCategories.map((menu) => (
                              <option key={menu.id} value={menu.id}>{menu.title}</option>
                            ))}
                          </select>
                        </div>

                        {subCategories.length > 0 && (
                          <div className="col-md-4">
                            <label className="form-label">
                              Sub Category<span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-select"
                              value={selectedSubCategory}
                              onChange={handleSubCategoryChange}
                              required
                            >
                              <option value="">Select Sub Category</option>
                              {subCategories.map((menu) => (
                                <option key={menu.id} value={menu.id}>{menu.title}</option>
                              ))}
                            </select>
                          </div>
                        )}

                        {subSubCategories.length > 0 && (
                          <div className="col-md-4">
                            <label className="form-label">
                              Instrument Type<span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-select"
                              value={selectedSubSubCategory}
                              onChange={handleSubSubCategoryChange}
                              required
                            >
                              <option value="">Select Instrument Type</option>
                              {subSubCategories.map((menu) => (
                                <option key={menu.id} value={menu.id}>{menu.title}</option>
                              ))}
                            </select>
                          </div>
                        )}

                        {subSubSubCategories.length > 0 && (
                          <div className="col-md-4">
                            <label className="form-label">
                              Make/Brand<span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-select"
                              value={selectedSubSubSubCategory}
                              onChange={handleSubSubSubCategoryChange}
                              required
                            >
                              <option value="">Select Make/Brand</option>
                              {subSubSubCategories.map((menu) => (
                                <option key={menu.id} value={menu.id}>{menu.title}</option>
                              ))}
                            </select>
                          </div>
                        )}

                        {finalCategories.length > 0 && (
                          <div className="col-md-4">
                            <label className="form-label">
                              Modal Number<span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-select"
                              id="listingCategory"
                              name="listingCategory"
                              value={selectedFinalCategory}
                              onChange={handleFinalCategoryChange}
                              required
                            >
                              <option value="">Select Final Category</option>
                              {finalCategories.map((menu) => (
                                <option key={menu.id} value={menu.id}>{menu.title}</option>
                              ))}
                            </select>
                          </div>
                        )}

                        {sixCategories.length > 0 && (
                          <div className="col-md-4">
                            <label className="form-label">6th Level Category</label>
                            <select
                              className="form-select"
                              value={selectedSixCategory}
                              onChange={handleSixCategoryChange}
                            >
                              <option value="">Select 6th Level Category</option>
                              {sixCategories.map((menu) => (
                                <option key={menu.id} value={menu.id}>{menu.title}</option>
                              ))}
                            </select>
                          </div>
                        )}

                        {seventhCategories.length > 0 && (
                          <div className="col-md-4">
                            <label className="form-label">7th Level Category</label>
                            <select
                              className="form-select"
                              value={selectedSeventhCategory}
                              onChange={handleSeventhCategoryChange}
                            >
                              <option value="">Select 7th Level Category</option>
                              {seventhCategories.map((menu) => (
                                <option key={menu.id} value={menu.id}>{menu.title}</option>
                              ))}
                            </select>
                          </div>
                        )}

                        {eightCategories.length > 0 && (
                          <div className="col-md-4">
                            <label className="form-label">8th Level Category</label>
                            <select
                              className="form-select"
                              value={selectedEightCategory}
                              onChange={handleEightCategoryChange}
                            >
                              <option value="">Select 8th Level Category</option>
                              {eightCategories.map((menu) => (
                                <option key={menu.id} value={menu.id}>{menu.title}</option>
                              ))}
                            </select>
                          </div>
                        )}

                        {nineCategories.length > 0 && (
                          <div className="col-md-4">
                            <label className="form-label">9th Level Category</label>
                            <select
                              className="form-select"
                              value={selectedNineCategory}
                              onChange={handleNineCategoryChange}
                            >
                              <option value="">Select 9th Level Category</option>
                              {nineCategories.map((menu) => (
                                <option key={menu.id} value={menu.id}>{menu.title}</option>
                              ))}
                            </select>
                          </div>
                        )}
                      </div>

                      {/* MPN */}
                      <div className="col-md-6">
                        <label htmlFor="mpn" className="form-label">MPN</label>
                        <input
                          type="text"
                          id="mpn"
                          name="mpn"
                          className="form-control"
                          placeholder="Enter MPN"
                          value={formData.mpn}
                          onChange={handleInputChange}
                        />
                      </div>

                      {/* HSN */}
                      <div className="col-md-6">
                        <label htmlFor="hsn" className="form-label">HSN</label>
                        <input
                          type="text"
                          id="hsn"
                          name="hsn"
                          className="form-control"
                          placeholder="Enter HSN"
                          value={formData.hsn}
                          onChange={handleInputChange}
                        />
                      </div>

                      {/* Country */}
                      <div className="col-md-6">
                        <label htmlFor="manufacturer" className="form-label">
                          Country/Region of Manufacturing
                        </label>
                        <select
                          id="manufacturer"
                          name="manufacturer"
                          className="form-select"
                          value={formData.manufacturer}
                          onChange={handleInputChange}
                        >
                          <option value="">Select Country/Region</option>
                          {countries.map((country) => (
                            <option key={country.id} value={country.id}>
                              {country.country_name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Available At */}
                      <div className="col-md-6">
                        <label htmlFor="availableat" className="form-label">
                          Item Available At
                        </label>
                        <input
                          type="text"
                          id="availableat"
                          name="availableat"
                          className="form-control"
                          placeholder="Enter Availibility Location"
                          value={formData.availableat}
                          onChange={handleInputChange}
                        />
                        <small><i>(Add Item Available Location)</i></small>
                      </div>

                      {/* Listing Type */}
                      <div className="col-md-12">
                        <label className="form-label">
                          Listing Type<span className="text-danger">*</span>
                        </label>
                        <div className="d-flex">
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="listingType"
                              id="directSell"
                              value="directSell"
                              checked={formData.listingType === "directSell"}
                              onChange={handleInputChange}
                            />
                            <label className="form-check-label" htmlFor="directSell">
                              <strong>Sell Directly</strong>
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="listingType"
                              id="quoteRequest"
                              value="quoteRequest"
                              checked={formData.listingType === "quoteRequest"}
                              onChange={handleInputChange}
                            />
                            <label className="form-check-label" htmlFor="quoteRequest">
                              <strong>Request a Quote</strong>
                            </label>
                          </div>
                        </div>
                        {errors.listingType && (
                          <small className="text-danger">{errors.listingType}</small>
                        )}
                      </div>

                      {/* Product Type */}
                      <div className="col-md-6">
                        <label htmlFor="product_type" className="form-label">
                          Item / Product Type
                        </label>
                        <select
                          id="product_type"
                          name="product_type"
                          className="form-control"
                          value={formData.product_type}
                          onChange={handleInputChange}
                        >
                          <option value="">Select Item Type</option>
                          <option value="Deliverable Product">Deliverable Product</option>
                          <option value="Digital Product">Digital Product</option>
                          <option value="Digital Service">Digital Service</option>
                          <option value="On site service">On site service</option>
                        </select>
                        <small><i>(This Indicate the type of Product / Item.)</i></small>
                      </div>

                      {/* Weight */}
                      <div className="col-md-6">
                        <label htmlFor="weight" className="form-label">
                          Item Weight (In Grams)
                        </label>
                        <input
                          type="text"
                          id="weight"
                          name="weight"
                          className="form-control"
                          placeholder="Enter Weight in Grams"
                          value={formData.weight}
                          onChange={handleInputChange}
                        />
                        <small><i>(Leave Blank Or 0 [Zero] for Digital Items)</i></small>
                      </div>

                      {/* Price */}
                      <div className="col-md-6">
                        <label htmlFor="price" className="form-label">
                          Price<span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <input
                            type="number"
                            id="price"
                            name="price"
                            className={`form-control ${errors.price ? "is-invalid" : ""}`}
                            placeholder="Enter price"
                            value={formData.price}
                            onChange={handleInputChange}
                            required
                          />
                          <select
                            id="currency"
                            name="currency"
                            className="form-control"
                            value={formData.currency}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="INR">INR</option>
                            <option value="USD">USD</option>
                            <option value="EUR">EUR</option>
                          </select>
                        </div>
                        {errors.price && (
                          <small className="text-danger">{errors.price}</small>
                        )}
                      </div>

                      {/* MRP */}
                      <div className="col-md-2">
                        <label htmlFor="mrp" className="form-label">MRP</label>
                        <div className="input-group">
                          <input
                            type="number"
                            id="mrp"
                            name="mrp"
                            className="form-control"
                            placeholder="Enter mrp"
                            value={formData.mrp}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      {/* Quantity */}
                      <div className="col-md-6">
                        <label htmlFor="quantity" className="form-label">
                          Stock Quantity Available<span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          id="quantity"
                          name="quantity"
                          className={`form-control ${errors.quantity ? "is-invalid" : ""}`}
                          placeholder="Enter quantity"
                          value={formData.quantity}
                          onChange={handleInputChange}
                          disabled={formData.unlimitedQuantity}
                          required={!formData.unlimitedQuantity}
                        />
                        <div className="form-check mt-2">
                          <input
                            type="checkbox"
                            id="unlimitedQuantity"
                            name="unlimitedQuantity"
                            className="form-check-input"
                            checked={formData.unlimitedQuantity}
                            onChange={handleCheckboxChange}
                          />
                          <label className="form-check-label" htmlFor="unlimitedQuantity">
                            Unlimited Qty Available
                          </label>
                        </div>
                        {errors.quantity && (
                          <small className="text-danger">{errors.quantity}</small>
                        )}
                      </div>

                      {/* Unit Quantity */}
                      <div className="col-md-6">
                        <label htmlFor="unitquantity" className="form-label">Unit Quantity</label>
                        <input
                          type="text"
                          id="unitquantity"
                          name="unitquantity"
                          className="form-control"
                          placeholder="Enter Unit Quantity"
                          value={formData.unitquantity || "1"}
                          onChange={handleInputChange}
                        />
                      </div>

                      {/* Listing Standard — ✅ FIXED: now uses errors.listingStandard */}
                      <div className="col-md-6">
                        <label htmlFor="listingStandard" className="form-label">
                          Listing Standard<span className="text-danger">*</span>
                        </label>
                        <select
                          id="listingStandard"
                          name="listingStandard"
                          className={`form-control ${errors.listingStandard ? "is-invalid" : ""}`}
                          value={formData.listingStandard}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select a Standard</option>
                          <option value="Piece (pc)">Piece (pc)</option>
                          <option value="Set (set) of">Set (set) of</option>
                          <option value="Pack (pack) of">Pack (pack) of</option>
                          <option value="Box (box) of">Box (box) of</option>
                          <option value="Gram (g)">Gram (g)</option>
                          <option value="Kilogram (kg)">Kilogram (kg)</option>
                          <option value="Milligram (mg)">Milligram (mg)</option>
                          <option value="Ton (t)">Ton (t)</option>
                          <option value="Millimeter (mm)">Millimeter (mm)</option>
                          <option value="Centimeter (cm)">Centimeter (cm)</option>
                          <option value="Meter (m)">Meter (m)</option>
                          <option value="Inche (in)">Inche (in)</option>
                          <option value="Foot (ft)">Foot (ft)</option>
                          <option value="Milliliter (ml)">Milliliter (ml)</option>
                          <option value="Liter (l)">Liter (l)</option>
                          <option value="Cubic Centimeter (cc)">Cubic Centimeter (cc)</option>
                          <option value="Cubic Meter (m3)">Cubic Meter (m3)</option>
                        </select>
                        {/* ✅ FIXED: was incorrectly showing errors.listingCondition here */}
                        {errors.listingStandard && (
                          <small className="text-danger">{errors.listingStandard}</small>
                        )}
                      </div>

                      {/* GST */}
                      <div className="col-md-2">
                        <label htmlFor="gst" className="form-label">GST</label>
                        <select
                          id="gst"
                          name="gst"
                          className="form-control"
                          value={formData.gst || ""}
                          onChange={handleInputChange}
                        >
                          <option value="">Select GST</option>
                          <option value="5">5%</option>
                          <option value="12">12%</option>
                          <option value="18">18%</option>
                          <option value="28">28%</option>
                        </select>
                      </div>

                      {/* Description */}
                      <div className="col-md-12">
                        <label htmlFor="description" className="form-label">Description</label>
                        <ReactQuill
                          value={formData.description}
                          ref={quillRef}
                          onChange={handleDescriptionChange}
                          modules={{
                            toolbar: [
                              ["bold", "italic", "underline", "strike"],
                              ["fontSize", "color"],
                              [{ align: [] }],
                              [{ list: "ordered" }, { list: "bullet" }],
                              ["link"],
                              ["blockquote"],
                              ["code-block"],
                              ["undo", "redo"],
                            ],
                          }}
                          formats={[
                            "bold", "italic", "underline", "strike",
                            "color", "align", "list", "bullet",
                            "link", "blockquote", "code-block",
                          ]}
                          className="quill-editor"
                        />
                        {errors.description && (
                          <small className="text-danger">{errors.description}</small>
                        )}
                      </div>

                      {/* File Upload — ✅ FIXED: inline error now shown */}
                      <div className="col-md-12">
                        <label htmlFor="images" className="form-label">
                          Upload Image/Video{" "}
                          {/* (Use png, jpg, jpeg, webp for images and mp4 for videos){" "}
                          (use 1:1 aspect ratio for images and max 30 seconds for videos) */}
                          <span className="text-danger">*</span>
                        </label>
                        <div
                          {...getRootProps({
                            className: "dropzone",
                            style: {
                              border: `2px dashed ${errors.uploadedFiles ? "#dc3545" : "#ccc"}`,
                              padding: "20px",
                              textAlign: "center",
                              cursor: "pointer",
                              position: "relative",
                            },
                          })}
                        >
                          <input {...getInputProps()} />
                          <p>Drag & drop files here, or click to select (Max: 10, 1 video)</p>
                        </div>

                        {/* ✅ FIXED: uploadedFiles error now shown inline */}
                        {errors.uploadedFiles && (
                          <small className="text-danger">{errors.uploadedFiles}</small>
                        )}

                        <div className="mt-3 d-flex flex-wrap">
                          {previewFiles.map((preview, index) => (
                            <div key={index} className="position-relative m-2">
                              {uploadedFiles[index].type.startsWith("image/") ? (
                                <img
                                  src={preview}
                                  alt="Preview"
                                  style={{ width: 100, height: 100, objectFit: "contain" }}
                                />
                              ) : (
                                <video src={preview} width={100} height={100} controls />
                              )}
                              <button
                                type="button"
                                className="btn btn-danger btn-sm position-absolute"
                                style={{ top: 0, right: 0 }}
                                onClick={() => removeFile(index)}
                              >
                                ❌
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Submit */}
                      <div className="col-md-12 mt-3 text-end">
                        <button
                          type="submit"
                          className="btn submitbtnn w-25 me-2"
                          disabled={!formData.title || isLoading}
                        >
                          {isLoading ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2"></span>
                              Creating...
                            </>
                          ) : (
                            "Create Listing"
                          )}
                        </button>
                      </div>

                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SellerListingCreate;
